import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'My players pay for original content. Won’t this feel like a store-bought module?',
  a: 'Every session is built from situations, not a fixed plot: three flexible scenes, two personalization hooks per character, and a “Make it yours in 10 minutes” step on every Table Kit. Volumes 2 and 4 show how to drop an arc into your own world in 15 minutes.'
}, {
  q: 'My players always go off-script. What then?',
  a: 'That’s why each scene has several exits instead of one path, and why the pack includes a d12 complications table and a pacing clock for when you’re 30 minutes behind.'
}, {
  q: 'Does it work on my VTT? Can I print it?',
  a: 'It works on any VTT or at a physical table. Every Table Kit has a VTT note, an in-person setup and an asset list. Pages are landscape PDFs that read on a tablet and print cleanly. Maps are working schematics, not illustrated battle maps.'
}, {
  q: 'I already own the 5E rulebooks. Why do I need this?',
  a: 'The rulebooks give you rules and monsters; they don’t give you tonight’s session. This gives you 57 of them, ready to run, plus the formats to keep a paid table coming back.'
}, {
  q: 'Is this zero prep?',
  a: 'No, and we don’t promise that. Each session is one Run Sheet you read in about 20 minutes, plus an optional 10 minutes to make it yours.'
}, {
  q: 'What does “5E compatible” mean here?',
  a: 'Every creature and item comes from the SRD 5.2.1, used under the CC-BY license, so you can run the sessions with the 5E-compatible rules you already use. The attribution is in the footer and on page 2 of every volume.'
}, {
  q: 'Do I have to start at Session 1?',
  a: 'No. Bonus 01, the 52-Week Table Calendar, tells you which session to run first for your type of table, and each volume works on its own.'
}, {
  q: 'Can I use it for corporate tables, birthdays or kids?',
  a: 'Yes. Volume 5 has ten event sessions with an Audience Dial, a kid-table tone guide and a rules-in-five-minutes script for guests who have never played.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-cream text-ink" data-id="element-74" data-mp="1fpvkb327ojff">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-75" data-mp="2dexgqpjuyyv8">
        <div className="text-center" data-id="element-76" data-mp="28gcgwr8iqh7b">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-77" data-mp="28hf3imyt5xhf">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-78" data-mp="1zg7jn9x1gz6v">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-79" data-mp="o096ouyqpt0d">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-cream-dark bg-white" data-id="element-80" data-mp="2zpp46b1nyi10" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-semibold text-plum focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-81" data-mp="38oaifu03ravz">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-82" data-mp="3rgld50kls2j0" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-83" data-mp="1x2c44vkbeobf" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-84" data-mp="16sa2whnf1ozr">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}